import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-574d2808"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bar-container"
}
const _hoisted_2 = {
  key: 0,
  class: "box card"
}
const _hoisted_3 = {
  key: 2,
  class: "pertext"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Accede a tu cuenta para visualizar tu progreso.", -1))
const _hoisted_6 = [
  _hoisted_5
]

import { useAuth } from '@/store/useAuth'
import SharedService from '@/services/SharedService'
import { onMounted, ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoadmapProgressbar',
  props: ['roadmapId'],
  setup(__props) {

const store = useAuth()
const sharedService = new SharedService()
const props = __props
const totalLessons = ref(0)
const lessonsCompleted = ref(0)
const loading = ref(true)
const percentage = computed(() => {
    if ((lessonsCompleted.value == 0) || (totalLessons.value == 0)) {
        return '0%'
    }
    const value = (lessonsCompleted.value * 100) / totalLessons.value
    const round = value.toFixed(0)
    return `${round}%`
})

onMounted(async () => {
    if (!store.token) {
        return
    }
    lessonsCompleted.value = await sharedService.countLessonsCompletedInRoadmap(store.token, props.roadmapId)
    totalLessons.value = await sharedService.countLessonsInRoadmap(store.token, props.roadmapId)
    loading.value = false
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_unref(store).token)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon"
              })
            ]))
          : _createCommentVNode("", true),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "progress",
              style: _normalizeStyle({ width: percentage.value })
            }, null, 4))
          : _createCommentVNode("", true),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(percentage.value) + " completado", 1))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
}
}

})